import React, { useEffect, useContext, useState } from 'react';
import logo from '../logo.svg';
import axios from 'axios';
import '../App.css';
import { useHistory } from "react-router-dom";
import { uuid } from 'uuidv4';
// function postClass(classSelection){
//     var myParam = {
//         class: classSelection
//     }

//     axios.post("http://localhost:5000/tutorProfile",myParam)
//   .then(function (response) {
//     //window.location.reload(true);
//     console.log(response);
//   })
//   .catch(function (error) {
//     console.log(error);
//   });
// }





//reserve/CSCE333

class homePage extends React.Component {
    //state = { selectedOption: "" };
    constructor(props) {
        super(props);
        this.state = { 
          classSelection: "",
          selectedOption: "simple",
         };
        this.submitter = this.submitter.bind(this);
        this.search = this.search.bind(this);
        //this.handleInputChange = this.handleInputChange.bind(this);
      }

    
      handleInputChange = (event) => {
        console.log("Changing", event.target.name);
        this.setState({
          [event.target.name]: event.target.value
        })
      }
      handleOptionChange = e => {
        //if (e.target.checked && e.target.value === "simple") { // if value of "No" option is selected
          //this.props.history.push("/chats"); // navigate to another route
          //window.location.href = "https://www.google.com"; - if you want to navigate to another page
          console.log("Changing", e.target.name,"to",e.target.value);
    
          this.setState({ selectedOption: e.target.value });
        //}
        //this.setState({ selectedOption: e.target.value });
      };

    submitter(e){
        console.log("submitting class request");
        e.preventDefault();
        localStorage.setItem('sessionID',uuid());     
        localStorage.setItem('classSelection', this.state.classSelection); 
        if(this.state.selectedOption === "simple"){
            this.search("/shortTransaction");
        }
        if(this.state.selectedOption === "schedule"){
            this.search("/tutorTable");
        }
        // postTutorDb(this.state.name,this.state.email,this.state.paypal, this.state.price, this.state.classes, this.state.classYear);
        console.log("Submit class request");
    }

    search(url)
    {
        var sample = this.state.classSelection;  
         
        var result = `?class=${sample}`; 
        //let history = useHistory();
        this.props.history.push({pathname: url,search: result });
    }


render() {
    const { selectedOption } = this.state;
    const { history } = this.props;
    return (

        <div className="App">
            <head>
                <title>Auxillia</title>
                {/* ION icons */}
                <link href = "https://unpkg.com/ionicons@4.5.10-0/dist/css/ionicons.min.css" rel = "stylesheet"></link>
                <link rel="stylesheet" href = "app.css"></link>
            </head>
            
            <body className = "App-header">
            
            
                <div class = "search">
                  <div class = "searchtitle">
                  <h1>Class Search</h1>
                  </div>
                
                <p>Enter the class you need help with</p>
                <p>Please Format as a 4 letter class code and 3 digit class code.</p>
                <p>EX: CSCE 333</p>
                
                <div>
                    <form onSubmit = {this.submitter}>
                    <input type = "text" name = "classSelection" placeholder = "Enter Class EX( CSCE 333)"  onChange = {this.handleInputChange}></input>
                    <p>Please select your purpose:</p>
                    <div className="radio">
          <label>
            <input
              type="radio"
              value = "simple"
              checked={selectedOption === "simple"}
              onChange={this.handleOptionChange}
            />
            Simple Question
          </label>
        </div>
        <div className="radio">
          <label>
            <input
              type="radio"
              value="schedule"
              checked={selectedOption === "schedule"}
              onChange={this.handleOptionChange}
            />
            Schedule
          </label>
        </div>
                    {/* <input type="radio" id="Schedule" name="Scheduler" value="Schedule" required></input>
                    <label for="Schedule"> Schedule</label><br></br>
                    
                    <input type="radio" id="simple" name="Scheduler" value="simple" required></input>
                    <label for="simple"> Simple Question</label><br></br> */}

                    <input type = "submit" name = "" value = "Submit" ></input >
                    
                    </form>
                </div>
                
            </div>
                
            

            
            
            </body>
            {/* <footer>
            <p>Contact us at jeffauxillium@gmail.com</p>
            <p>Have a Question? Here is our FAQ page<a href = "/App.js">FAQ</a></p>
            </footer> */}
        </div>
            


        //  <header className="App-header">
        //   <img src={logo} className="App-logo" alt="logo" />
        //   <p>
        //     Edit <code>src/App.js</code> and save to reload.
        //   </p>
        //   <p>
        //   Howdy!
        //   </p>
        //   <a
        //     className="App-link"
        //     href="https://reactjs.org"
        //     target="_blank"
        //     rel="noopener noreferrer"
        //   >
        //     Learn React
        //   </a>
        // </header>
        // <header className = "App-header">Howdy!</header>
        // <div id="grad1">wowza</div>
        
        
    );
    }
}

export default homePage;
